
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/torches",
      function () {
        return require("private-next-pages/[locale]/torches/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/torches"])
      });
    }
  